import React from 'react';

import type { INewPatientsData } from 'infrastructure/interfaces/';

interface IProps {
  data: INewPatientsData;
}

const ClinicColumn: React.FC<IProps> = ({ data }) => {
  return <div>{data.clinic.legalname}</div>;
};

export default ClinicColumn;
